module.exports = __webpack_public_path__ + "static/img/6.c0e4a04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/eng/6.png
// module id = myU/
// module chunks = 0